<route>
{
  "meta": {
    "customSite": true
  }
}
</route>
<template>
  <div class="my-0 mx-auto text-center">
    <h1>Join Implicit</h1>
    <p class="max-w-md mx-auto">
      Create an account to receive great articles sent to your inbox,
      personalize your homepage, and follow authors and topics that you find
      insightful.
    </p>
    <button
      v-on:click="signInWithTwitter"
      class="bg-primaryLight text-black text-center p-4 text-xl"
    >
      Sign up with Twitter
    </button>
    <p class="mt-4 max-w-md mx-auto">
      Click 'Sign Up' to agree to provide feedback as well as agree to our
      <a href="/terms">terms of service</a> and
      <a href="/privacy">privacy policy</a>.
    </p>
  </div>
</template>

<script>
import store from '@/store';
import firebase from '../../services/firebase';
import userInfo from '../../services/userInfo';

export default {
  name: 'Register',
  store,
  props: { creator: Object },
  data() {
    return {};
  },
  methods: {
    signInWithTwitter() {
      firebase.loginWithTwitter(this);
    },
  },
  mounted() {
    this.$root.$emit('cool_event_name', this.creator);
    store.commit('toggleLoading', true);
    firebase
      .getLoginResult(this)
      .then(
        async ({
          userId,
          userName,
          acctUsername,
          description,
          userEmail,
          isNewUser,
          profilePic,
          emailVerified,
          token,
          secret,
          providerId,
        }) => {
          store.commit('toggleLoading', false);
          if (isNewUser) {
            await userInfo.createNewUser(
              userId,
              userName,
              acctUsername,
              description,
              userEmail,
              profilePic,
              token,
              secret,
              providerId,
            );
          } else {
            await userInfo.updateUser(
              userId,
              userName,
              acctUsername,
              description,
              userEmail,
              profilePic,
              token,
              secret,
              providerId,
            );
          }
          const user = firebase.getCurrentUser();
          if (user.emailVerified) {
            await user.sendEmailVerification();
          }
          await store.commit('setSignedIn', {
            user: {
              email: userEmail,
              name: userName,
              uid: userId,
              isVerified: emailVerified,
              profilePic,
            },
            token,
          });
          const redirectPath = localStorage.getItem('redirectPath');
          if (redirectPath) {
            this.$router.push(redirectPath);
            localStorage.removeItem('redirectPath');
          } else {
            this.$router.push('/home');
          }
        },
      )
      .catch((err) => {
        store.commit('toggleLoading', false);
        console.log(err);
      });
  },
};
</script>
